/**
* Social Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Social Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'social-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.social-marquee-splide' ).length ) {
        $( '.social-marquee-splide' ).each( function( index, element ) {
          const section = $( this );
          const sectionWidth = section.width();
          const doubleSectionWidth = sectionWidth * 2;
          let iterations = 0;
          const maxIterations = 10;
          let totalWidth = 0;
          const slides = section.find( `.splide__slide` );
          slides.each( function() {
            totalWidth += $( this ).width();
          } );
          while ( totalWidth < doubleSectionWidth && iterations < maxIterations ) {
            if ( totalWidth < doubleSectionWidth ) {
              slides.each( function() {
                // Clone each slide and append it to the marquee-track
                const clonedSlide = $( this ).clone();
                section.find( `.splide__list` ).append( clonedSlide );
                // Update the total width with the width of the cloned slide
                totalWidth += clonedSlide.width();
              } );
            }
            iterations++;
          }

          new Splide( element, {
            type: 'loop',
            perPage: 1,
            autoWidth: true,
            gap: '40px',
            drag: false,
            pagination: false,
            arrows: false,
            perMove: 1,
            autoScroll: {
              speed: 0.4,
            },
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'social-marquee', COMPONENT );
} )( app );
